import { render, staticRenderFns } from "./InstitutionCrudModal.vue?vue&type=template&id=e43ff24e&"
import script from "./InstitutionCrudModal.vue?vue&type=script&lang=js&"
export * from "./InstitutionCrudModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports